module.exports = __webpack_public_path__ + "static/media/introduce_p4@2x.453dfce3.png";